import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shared',
  templateUrl: './shared.component.html',
  styleUrls: ['./shared.component.css']
})
export class SharedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  tableMockData = [
    {"test1": "TH 1","test1val":60 ,"test2": "TH 2", "test2val":10 ,"test3": "TH 3","test3val":15 , "test4": "TH 4","test4val":15 ,},
    
   
  ]
  getColor(priority,ele){
    switch (priority) {
      case 'TH 1':
        return {'background-color':'red','width':''+ele.test1val+'%'}
        break;
      case 'TH 2':
        return {'background-color':'orange','width':''+ele.test2val+'%'}
        break;
      case 'TH 3':
        return {'background-color':'blue','width':''+ele.test3val+'%'}
        break;
     
      case 'TH 4':
        return {'background-color':'green','font-weight': 'bold','width':''+ele.test4val+'%'}
        break;
    }
  }
}
